module.exports = __webpack_public_path__ + "img/icon-forex.8e7acd7b.svg";